import About from '@/views/About/About'
export default {
  name: 'AboutMobile',
  mixins: [About],
  computed: {
    authorizedAppsMobile () {
      const appsMobile = JSON.parse(sessionStorage.getItem('authorizedAppsMobile'))
      return appsMobile || []
    },
    computedStatus () {
      return status => {
        const appConfiguratorVersion = this.aboutApplications[status]?.version
        const appServiceVersion = this.serviceConfiguration[status]?.version
        return appConfiguratorVersion === appServiceVersion
      }
    }
  }
}
